import { useParams } from "react-router";

import blogs from '../assets/blog/blogs.json';
import Container from '../components/Container';
import BlogGallery from '../components/BlogGallery';
import Markdown from '../components/Markdown';
import Error from '../components/Error';
import ShareButton from '../components/ShareButton';
import { Utils } from '../Utils';

const Blog = () => {
    const { publishDate } = useParams();
    let children, title, margin = true;
    if (!publishDate) {
      margin = false;
      const text = `
  These are writeups of fun and interesting projects that I've done over the years. The goal is to educate and amuse,
  I will leave it up to the reader to decide whether or not I have succeeded.
      `
      children = (
        <>
          <div className="left-header">Blog</div>
          <Markdown children={text} />
          <BlogGallery blogs={blogs} />
        </>
        
      );
    } else {
      // /blog/<date> answers 200 for any date, so an unknown one has to render rather than throw
      // on the missing post. See SPA_ROUTES in server/app.js.
      const blog = blogs.find(b => b.publish_date === publishDate);

      if (!blog) {
        children = <Error code={404} msg={"No blog found on " + publishDate} />;
      } else {
        title = blog.title;   // A post names the tab itself, matching the served head
        const byline = (
          <>
            <span>
              <span className="author">{blog.author}</span>
              <span className="publish-date">{`${Utils.formatDate(blog.publish_date)}`}</span>
            </span>
            <span className="byline-actions">
              <span className="reading-time">{`${Utils.estimateReadingTime(blog.content)} min read`}</span>
              <ShareButton title={blog.title} />
            </span>
          </>
        );

        children = <Markdown mode="blog" byline={byline} title={blog.title} children={blog.content} />;
      }
    }
  
    return (
      <Container page="Blog" margin={margin} title={title}>{children}</Container>
    );
  }
  
  export default Blog;